export const IMOVEIS_ENDPOINTS = Object.freeze({
  externalProperties: 'external_properties',
  duplicateCandidates: 'duplicate_candidates',
  empreendimentos: 'empreendimentos',
  importXml: 'import_xml',
  importStatus: 'import_status',
  estimatePrice: 'estimate_price',
  taxFees: 'tax_fees',
  normalizeAddress: 'normalize_address',
  autocompleteAddress: 'autocomplete_address',
  nearby: 'nearby',
  completeAddress: 'complete_address',
  simulateFinancing: 'simulate_financing',
  reactivate: 'reactivate',
  publish: 'publish',
  unpublish: 'unpublish',
  suspendListing: 'suspend_listing',
  relist: 'relist',
  notifyAvailability: 'notify_availability',
  mediaQa: 'media_qa',
  portalSyncs: 'portal_syncs',
  listings: 'listings',
  versions: 'versions',
  diff: 'diff',
  lifecyclePreview: 'lifecycle_preview',
  ownerContact: 'owner_contact',
  weeklyCount: 'weekly_count',
  portfolio: 'portfolio',
  reveal: 'reveal',
  trackChannel: 'track_channel',
  recordAttempt: 'record_attempt',
  cancelImport: 'cancel_import',
  programarDestaque: 'programar_destaque',
  keyHandovers: 'key_handovers',
  similar: 'similar',
  trackRecommendationClick: 'track_recommendation_click',
  tenant: 'tenant',
  entryInformation: 'entry_information',
  entryAccesses: 'entry_accesses',
  identity: 'identity',
  aliases: 'aliases',
});

export const VISITAS_ENDPOINTS = Object.freeze({
  agenda: 'agenda',
  recommendations: 'recommendations',
  availability: 'availability',
  agentScheduleBlocks: 'agent_schedule_blocks',
  config: 'config',
  bulk: 'bulk',
  imovelKeyHandovers: 'imovel_key_handovers',
  agentKeys: 'agent_keys',
  pickup: 'pickup',
  return: 'return',
  notDelivered: 'not_delivered',
  finish: 'finish',
  checkIn: 'check_in',
  outcome: 'outcome',
  finalizeOutcome: 'finalize_outcome',
  issueFeedbackToken: 'issue_feedback_token',
  approveConfirmationAudit: 'approve_confirmation_audit',
  rejectConfirmationAudit: 'reject_confirmation_audit',
  reviewReport: 'review_report',
  requestFeedback: 'request_feedback',
  batchCancel: 'batch_cancel',
  reschedule: 'reschedule',
});

export const PROPERTY_OFFERS_ENDPOINTS = Object.freeze({
  accept: 'accept',
  decline: 'decline',
  withdraw: 'withdraw',
  counter: 'counter',
  creditAnalysis: 'credit_analysis',
  contract: 'contract',
  generate: 'generate',
  sync: 'sync',
  resendSigner: 'resend_signer',
  cancel: 'cancel',
  kycVerifications: 'kyc_verifications',
  kycChecklist: 'checklist',
  kycReview: 'review',
  timeline: 'timeline',
  statusList: 'status_list',
  sendOfferLink: 'send_offer_link',
  revokePublicToken: 'revoke_public_token',
  reissuePublicToken: 'reissue_public_token',
});

export const OPEN_HOUSE_ENDPOINTS = Object.freeze({
  metrics: 'metrics',
  schedule: 'schedule',
  open: 'open',
  close: 'close',
  cancel: 'cancel',
  register: 'register',
  confirm: 'confirm',
  cancelRegistration: 'cancel_registration',
  promote: 'promote',
  noShow: 'no_show',
  checkIn: 'check_in',
  walkIn: 'walk_in',
  convert: 'convert',
});

export const KEY_RESERVATIONS_ENDPOINTS = Object.freeze({
  cancel: 'cancel',
});

export const ACCESS_ASSETS_ENDPOINTS = Object.freeze({
  block: 'block',
  reserve: 'reserve',
  timeline: 'timeline',
  unblock: 'unblock',
});

export const RESERVATION_HOLDS_ENDPOINTS = Object.freeze({
  timeline: 'timeline',
  confirm: 'confirm',
  release: 'release',
  cancel: 'cancel',
});

export const PROPERTY_TRANSACTIONS_ENDPOINTS = Object.freeze({
  timeline: 'timeline',
  dueItems: 'due_items',
  start: 'start',
  completeItem: 'complete_item',
  reopenItem: 'reopen_item',
  waiveItem: 'waive_item',
  blockItem: 'block_item',
  unblockItem: 'unblock_item',
  extendDeadline: 'extend_deadline',
  addEvidence: 'add_evidence',
  planInstallments: 'plan_installments',
  complete: 'complete',
  cancel: 'cancel',
});

export const VISITOR_INFO_ENDPOINTS = Object.freeze({
  suggestions: 'suggestions',
  houses: 'houses',
  nextVisits: 'next_visits',
  lastVisits: 'last_visits',
  history: 'history',
  ongoingOffers: 'ongoing_offers',
});

export const PORTAL_INTEGRATIONS_ENDPOINTS = Object.freeze({
  status: 'status',
  preflight: 'preflight',
  configure: 'configure',
  authorizeUrl: 'authorize_url',
  callback: 'callback',
  publish: 'publish',
  reconcile: 'reconcile',
  import: 'import',
});

export const LAIS_ENDPOINTS = Object.freeze({
  imoveis: IMOVEIS_ENDPOINTS,
  visitas: VISITAS_ENDPOINTS,
  propertyOffers: PROPERTY_OFFERS_ENDPOINTS,
  openHouse: OPEN_HOUSE_ENDPOINTS,
  accessAssets: ACCESS_ASSETS_ENDPOINTS,
  keyReservations: KEY_RESERVATIONS_ENDPOINTS,
  reservationHolds: RESERVATION_HOLDS_ENDPOINTS,
  propertyTransactions: PROPERTY_TRANSACTIONS_ENDPOINTS,
  visitorInfo: VISITOR_INFO_ENDPOINTS,
  portalIntegrations: PORTAL_INTEGRATIONS_ENDPOINTS,
});

export default LAIS_ENDPOINTS;
